import React from "react";
import about from "./about.module.css";
import logo from "../../../Assets/About/why choose us.svg";
import defaultIMG from "../../../Assets/defaultimg.png";

const Insurence = () => {
  return (
    <div className={about.insurence_container}>
      <div className={about.insure_miancontainer}>
        <div
          className={about.insurencetext_container}
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <p className={about.insureheader}>Why choose us</p>
          <h1 className={about.insuretext}>
            Empowering Business Growth with Comprehensive Compliance and IPO
            Solutions
          </h1>
          <p className={about.insurep}>
            At Kohere Connect Private Limited, we offer a complete suite of
            business services designed to support growth, from compliance
            management to IPO preparation. Partnering with top professionals, we
            provide tools like compliance calendars and AI-powered analytics to
            streamline operations and reduce risk. Our platform enhances
            security with blockchain technology and ensures an intuitive,
            mobile-friendly user experience. By focusing on client needs, we
            deliver personalized, reliable solutions.
          </p>
          {/* <div className={about.insurecount_container}>
            <div className={about.Indurecount_info}>
              <p className={about.Insurenumber}>75k</p>
              <p className={about.Insureptext}>
                Project Completed
                <br />
                Last Years
              </p>
            </div>
            <div className={about.Indurecount_info}>
              <p className={about.Insurenumber}>75k</p>
              <p className={about.Insureptext}>
                Project Completed
                <br />
                Last Years
              </p>
            </div>
          </div> */}
          {/* <button type="button" className={about.connectbtn}>
            Discover More
          </button> */}
        </div>
        <div
          className={about.Insurece_img_container}
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <img src={logo}
             onError={({ currentTarget }) => {
              currentTarget.onerror = null; 
              currentTarget.src= defaultIMG ;
            }}
           alt="image" className={about.insurence_img} />
        </div>
      </div>
    </div>
  );
};

export default Insurence;
